// After a write to the docs domain, forget the cached note lists.
//
// The list queries — documentsFetch / notesFetch / kbArticlesFetch (index.js),
// the home Documents tile and the files desktop's docs — keep their answer for
// 30 s (the KB list 1 m) and hand it to every page that mounts in that window,
// which writes those rows back into the root stores. So a write that patched
// the stores in place was undone by the next mount: the note deleted in the
// editor stood on the list the editor returned to, and a card dropped on a
// folder went back to its old folder, until a reload (measured on dev
// 2026-10-27: back within 3 s of the write).
//
// Removing the entries makes the next mount ask the server; until that answer
// lands, the stores show the rows the write patched. Removal, not
// invalidation: an invalidation also refetches every mounted list at once, and
// the editor's autosave writes every few seconds.
//
// Cache keys start with the query's `from` — `docs:…`, `docs.notes:…`,
// `docs.kbArticles:…` (@symbo.ls/fetch queryCacheKey). `removeQueries` is the
// fetch plugin's registered function; with no fetch plugin there is no cache,
// and `call` returns nothing.
export const forgetDocLists = function () {
  this.call('removeQueries', /^docs[.:]/)
}
